<template>
  <div class="modal nb-modal-mask" style="display:block; z-index: 1 !important;">
    <Trap>
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document" style="width: 90vh!important; overflow-y: initial !important">
      <div class="modal-content">
        <div class="modal-body pt-3" style="height: 80vh!important; max-height: 100%; overflow-y: auto;">
          <warnings :messages="['Selecione um caixa para iniciar as vendas!']"></warnings>
          <div class="lbl mb-2" style="font-size: 20px">
            <strong>Abertura do Caixa</strong>
          </div>
          <div class="row">
            <div class="col-md-6 col-12 mb-3">
              <span class="lbl-edit">Operador</span><br>
              <span class="lbl"> <strong>{{ usuarionome }}</strong> </span>
            </div>
            <div class="col-md-6 col-12 mb-3">
              <span class="lbl-edit">Data da Operação</span><br>
              <span class="lbl">  <strong> {{ vabertura.data | formatData }} </strong> </span>
            </div>
          </div>
          <div class="row">
            <!-- <form-field v-model="codvcaixa" type="select2" col="12" :metadata="{ fieldname: 'codvcaixa', label: 'Selecione o Caixa', select2: { entity: 'vcaixa', minlength: 0 } }"
              name="codvcaixa" :v-errors="errors" v-validate="{ required: true }"></form-field> -->
            <!-- <div class="col-12">
              <div class="form-group">
                  <v-label label="Selecione o Caixa"></v-label>
                  <select2 v-model="codvcaixa" name="codvcaixa" multiple size="6"
                      :options="{}" 
                      :value="codvcaixa" 
                      v-validate="{required: true}"
                      entity="vcaixa"
                      :minlength="0"
                      :focus="setFocusCaixa">
                  </select2>
                  <small class="error" v-if="errors.has('ufori')">{{ errors.first('ufori') }}</small>
                </div>
            </div> -->
            <div class="col-md-12 col-12 mb-2">
              <span class="lbl-deal-title">Selecione o caixa para abertura</span>
            </div>
            <div class="col-12 mb-3">
              <select ref="listCaixas" 
                  class="form-control" multiple size="4" 
                  style="font-size: 17px"
                  :value="codvcaixa" 
                  @change="selectCaixa"
                  @keydown.enter="handleFocus()">
                <option v-for="opt in listCaixas" :key="opt.id" :value="opt.id">{{ opt.value }}</option>
              </select>
            </div>
          </div>

          <!-- <validation v-if="aberturadecaixa" :messages="['Efetue a abertura do caixa para iniciar as vendas!']"></validation> -->
          <!-- <alert type="info" title="Abertura do caixa" text="Efetue a abertura do caixa para prosseguir."></alert> -->
          <div class="row" v-if="aberturadecaixa">
            <!-- <div class="col-md-6 col-6">
              <form-field v-model="vabertura.codfil" type="select2" col="12" :metadata="metadata.vabertura.codfil"
                name="codfil" :v-errors="errors" v-validate="metadata.vabertura.codfil.validator"></form-field>
            </div> -->
            <div class="col-md-12 col-12 mb-3">
              <span class="lbl-deal-title">Informe o valor inicial de abertura do caixa</span>
            </div>
            <div class="w-100"></div>
            <form-field id="valor" v-model="vabertura.valor" type="value" :precision="2" col="6"
              :metadata="metadata.vabertura.valor" name="valor" ref="valor" :v-errors="errors"
              v-validate="metadata.vabertura.valor.validator"></form-field>
            <div class="col-md-6 col-6 mb-3" v-if="valor_ultimo_fechamento">
              <span class="lbl-edit">Valor Fechamento Anterior</span><br>
              <span class="lbl-edit"><strong>{{ valor_ultimo_fechamento | formatValue(2,true)}}</strong></span>
            </div>
            <form-field v-model="vabertura.obs" type="text" col="12" :metadata="metadata.vabertura.obs" name="obs"
              :v-errors="errors" v-validate="metadata.vabertura.obs.validator"></form-field>
          </div>

          <!-- quando caixa estiver aberto -->
          <alert v-if="caixaaberto" type="info" title="Aviso" :text="'O caixa já está aberto. O operador atual é ' + nomeoperador + '. Clique em confirmar para prosseguir.'"/>
        </div>
        <div class="modal-footer">
              <v-button ref="btnConfirma" label="Confirmar" :success="true" @click="handleFinaliza"></v-button>
              <v-button label="Fechar" @click="handleRetorna"></v-button>
        </div>
      </div>
    </div>
  </Trap>
  </div>
</template>

<script>

import Trap from "vue-focus-lock";
import { formatDate, formatValue } from '../shared/utils'
import { apiORDS } from '../shared/api-functions'

export default {
  props: {
    params: {},
  },

  data() {
    return {
      lCrud: 'ins',

      vabertura: {
        codvcaixa: null,
        codfil: null,
        valor: 0,
        obs: null,
        data: null,
      },

      listCaixas: [],
      codvcaixa: null,
      caixaaberto: false,
      aberturadecaixa: false,
      nomeoperador: null,
      uuidoperador: null,
      valor_ultimo_fechamento: 0,
      setFocusCaixa: false,
    }
  },

  computed: {

    metadata: function () {
      return this.$store.getters.getEntities.metadata
    },

    usuarionome: function () {
      return this.$store.getters.getEnv.usuarionome
    },

    uuid: function () {
      return this.$store.getters.getEnv.uuid
    },

  },

  watch: {
      codvcaixa: function () {
        this.aberturadecaixa = false

        if (this.codvcaixa) {
          this.vabertura.codvcaixa = this.codvcaixa
          this.loadData()
        }
      },
  },

  filters: {

  },

  methods: {
    selectCaixa(evt) {
      this.codvcaixa = evt.target.value;
    },

    loadCaixaOptions() {
      this.listCaixas = []
      let self = this
      apiORDS(this.$store.getters.urlOrds + 'varejo/caixas', null, true).then((result) => {
        result.items.forEach((caixa, idx) => {
          if (caixa.aberto == 'S')
            self.listCaixas.push({ id: caixa.codvcaixa, value: caixa.caixa + ' (ABERTO)'})
          else
            self.listCaixas.push({ id: caixa.codvcaixa, value: caixa.caixa })
        })
      });
    },

    handleRetorna() {
      //BOTAO RETORNAR PARA VENDA
      this.$emit('resultadovabertura', null, 'RETORNA')
    },

    handleFinaliza() {
      //retorna os dados do pagamento para o objeto pai
      //emite o evento "finaliza"
      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
        } else {
          this.$emit('resultadovabertura', this.vabertura, 'OK')
        }
      })
    },

    async loadData() {
      this.caixaaberto = false
      const data = await apiORDS(this.$store.getters.urlOrds + 'varejo/ultimofechamento/' + this.vabertura.codvcaixa, null)
      if (data) {
        this.valor_ultimo_fechamento = data.valor_ultimo_fechamento
        this.caixaaberto = data.caixaaberto
        this.nomeoperador = data.nomeoperador
        this.uuidoperador = data.uuid
        this.vabertura.codvabertura = data.codvabertura
      }
      this.aberturadecaixa = !this.caixaaberto
      this.vabertura.aberturadecaixa = !this.caixaaberto
      this.vabertura.data = this.$getDate()
    },

    handleFocus() {
      if (this.caixaaberto) {
        this.$refs.btnConfirma.focus()
      } else {
        this.$refs.valor.focus()
      }
    }

  },

  components: {
    Trap,
  },

  created() {


  },

  mounted() {
    this.vabertura.data = this.$getDate()

    this.loadCaixaOptions()
    let self = this
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip()
      self.$refs.listCaixas.focus()
      console.log('aqui')
      console.log(self.$refs.listCaixas)
      // self.setFocusCaixa = true
    })



  }

}

</script>





<style scoped>



</style>


// WEBPACK FOOTER //
// src/forms-varejo/varejo-vabertura-form.vue